// Componente para el botón de gestionar productos externos excluidos
// Maneja la apertura del modal y verificación de permisos
import { Button } from '@shared/components/ui/button';
import { usePermissions } from '@shared/hooks/usePermissions';
import { useTranslation } from 'react-i18next';

interface ExternalExcludedProductsButtonProps {
  /** Función que se ejecuta al hacer clic en el botón */
  onOpenModal: () => void;
}

/**
 * Componente para el botón de gestionar productos externos excluidos
 * Maneja la verificación de permisos y la apertura del modal
 */
export const ExternalExcludedProductsButton = ({ onOpenModal }: ExternalExcludedProductsButtonProps) => {
  const { t } = useTranslation('productsModule');
  const { canAccess } = usePermissions();

  // Verificar permisos para gestionar productos externos excluidos
  // Solo disponible para tenant_external y tenant_3pl con permiso products.view
  const canManageExternalExcluded = canAccess(['tenant_external', 'tenant_3pl'], ['products.view']);

  // Si no tiene permisos, no mostrar el botón
  if (!canManageExternalExcluded) {
    return null;
  }

  return (
    <Button variant="outline" size="lg" onClick={onOpenModal} data-testid="external-excluded-products-button">
      {t('external_excluded.button')}
    </Button>
  );
};
